module.exports = __webpack_public_path__ + "static/media/hero.00ed2a1e.jpg";